import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "@/lib/currencyFormatter";

interface RecentOrder {
  id: string;
  customer: string;
  items: number;
  total: number;
  status: string;
}

interface RecentOrdersListProps {
  orders: RecentOrder[];
  isLoading: boolean;
}

export const RecentOrdersList = ({
  orders,
  isLoading,
}: RecentOrdersListProps) => {
  const { t } = useTranslation();

  return (
    <Card className="animate-fade-in animate-delay-600">
      <CardHeader>
        <CardTitle>{t("recentOrders")}</CardTitle>
        <CardDescription>{t("recentOrdersDescription")}</CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex justify-center items-center h-20">
            <p>{t("loading")}</p>
          </div>
        ) : orders.length > 0 ? (
          <div className="space-y-4">
            {orders.map((order) => (
              <div
                key={order.id}
                className="flex items-center justify-between border-b pb-2 last:border-0"
              >
                <div>
                  <p className="font-medium">{order.customer}</p>
                  <p className="text-sm text-muted-foreground">
                    {order.items} {t("items")} •{" "}
                    {formatCurrency(Number(order.total))}
                  </p>
                </div>
                <span
                  className={`text-xs px-2 py-1 rounded-full ${
                    order.status === "Pending"
                      ? "bg-yellow-100 text-yellow-800"
                      : order.status === "Preparing"
                      ? "bg-blue-100 text-blue-800"
                      : order.status === "Ready"
                      ? "bg-green-100 text-green-800"
                      : order.status === "Delivered"
                      ? "bg-green-100 text-green-800"
                      : order.status === "Completed"
                      ? "bg-green-100 text-green-800"
                      : "bg-gray-100 text-gray-800"
                  }`}
                >
                  {t(order.status.toLowerCase())}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex justify-center items-center h-40">
            <p>{t("noRecentOrders")}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
